import { render, staticRenderFns } from "./ShapeChoose.vue?vue&type=template&id=b75cd038&"
import script from "./ShapeChoose.vue?vue&type=script&lang=js&"
export * from "./ShapeChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports